<template>
  <div id="forbidden">
    <img src="../assets/img/403.png" class="mx-auto d-block">

    <div class="text-center col-sm-12">
      <span class="vertical-5p lead">Back to <router-link to="/" class="vertical-5p lead">Home</router-link></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Forbidden'
}
</script>

<style>
#forbidden {
  padding: 2em;
  color: black;
}
</style>
